import { TranslationMessages } from "ra-core";

// Copied from https://github.com/greenbananaCH/ra-language-german/blob/4593f59ba284c39cfb37b6bf5bded05326d10f3c/index.js
const messages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Filter hinzufügen",
      add: "Neu",
      back: "Zurück",
      bulk_actions:
        "Ein Element ausgewählt |||| %{smart_count} Elemente ausgewählt",
      cancel: "Abbrechen",
      clear_input_value: "Eingabe löschen",
      clone: "Klonen",
      confirm: "Bestätigen",
      create: "Erstellen",
      create_item: "%{item} erstellen",
      delete: "Löschen",
      edit: "Bearbeiten",
      export: "Exportieren",
      list: "Liste",
      refresh: "Aktualisieren",
      remove_filter: "Filter entfernen",
      remove: "Entfernen",
      save: "Speichern",
      search: "Suchen",
      select_all: "Alle auswählen",
      select_row: "Zeile auswählen",
      show: "Anzeigen",
      sort: "Sortieren",
      undo: "Zurücksetzen",
      unselect: "Abwählen",
      expand: "Erweitern",
      close: "Schliessen",
      open_menu: "Öffnen des Menüs",
      close_menu: "Schliessen des Menüs",
      update: "Aktualisieren",
      move_up: "Nach oben verschieben",
      move_down: "Nach unten verschieben",
      open: "Öffnen",
      toggle_theme: "Theme wechseln",
      remove_all_filters: "Alle Filter entfernen",
      clear_array_input: "Liste löschen",
      select_columns: "Spalten",
      update_application: "Anwendung aktualisieren",
    },
    boolean: {
      true: "Ja",
      false: "Nein",
      null: " ",
    },
    page: {
      create: "%{name} erstellen",
      dashboard: "Dashboard",
      edit: "%{name} #%{id}",
      error: "Etwas ist schief gelaufen",
      list: "%{name}",
      loading: "Die Seite wird geladen.",
      not_found: "Nicht gefunden",
      show: "%{name} #%{id}",
      empty: "Noch kein %{name}.",
      invite: "Neu erstellen?",
    },
    input: {
      file: {
        upload_several:
          "Zum Hochladen Dateien hineinziehen oder hier klicken, um Dateien auszuwählen.",
        upload_single:
          "Zum Hochladen Datei hineinziehen oder hier klicken, um eine Datei auszuwählen.",
      },
      image: {
        upload_several:
          "Zum Hochladen Bilder hineinziehen oder hier klicken, um Bilder auszuwählen.",
        upload_single:
          "Zum Hochladen Bild hineinziehen oder hier klicken, um ein Bild auszuwählen.",
      },
      references: {
        all_missing:
          "Die zugehörigen Referenzen konnten nicht gefunden werden.",
        many_missing:
          "Mindestens eine der zugehörigen Referenzen scheint nicht mehr verfügbar zu sein.",
        single_missing:
          "Eine zugehörige Referenz scheint nicht mehr verfügbar zu sein.",
      },
      password: {
        toggle_visible: "Passwort verstecken",
        toggle_hidden: "Passwort anzeigen",
      },
    },
    message: {
      about: "Über",
      are_you_sure: "Bist du sicher?",
      bulk_delete_content:
        'Möchten Sie "%{name}" wirklich löschen? |||| Möchten Sie diese %{smart_count} Elemente wirklich löschen?',
      bulk_delete_title:
        "Lösche %{name} |||| Lösche %{smart_count} %{name} Elemente",
      bulk_update_content:
        "Möchten Sie %{name} wirklich aktualisieren? |||| Möchten Sie diese %{smart_count} Elemente wirklich aktualisieren?",
      bulk_update_title:
        "Aktualisiere %{name} |||| Aktualisiere %{smart_count} %{name}",
      delete_content: "Möchten Sie diesen Inhalt wirklich löschen?",
      delete_title: "Lösche %{name} #%{id}",
      details: "Details",
      error:
        "Ein Fehler ist aufgetreten und ihre Anfrage konnte nicht abgeschlossen werden.",
      invalid_form:
        "Das Formular ist ungültig. Bitte überprüfen Sie ihre Eingaben.",
      loading: "Die Seite wird geladen.",
      no: "Nein",
      not_found: "Die Seite konnte nicht gefunden werden.",
      yes: "Ja",
      unsaved_changes:
        "Einige Ihrer Änderungen wurden noch nicht gespeichert. Sind Sie sicher, dass Sie diese ignorieren wollen?",
      auth_error:
        "Bei der Prüfung des Authentifizierungs-Tokens ist ein Fehler aufgetreten.",
      clear_array_input: "Möchten Sie die komplette Liste löschen?",
    },
    navigation: {
      no_results: "Keine Resultate gefunden",
      no_more_results: "Die Seite %{page} enthält keine Inhalte.",
      page_out_of_boundaries:
        "Die Seite %{page} liegt ausserhalb des gültigen Bereichs",
      page_out_from_end: "Letzte Seite",
      page_out_from_begin: "Erste Seite",
      page_range_info: "%{offsetBegin}-%{offsetEnd} von %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} von mehr als %{offsetEnd}",
      current_page: "Seite %{page}",
      page: "Zur Seite %{page}",
      first: "Go to first page",
      last: "Go to last page",
      next: "Weiter",
      previous: "Go to previous page",
      page_rows_per_page: "Zeilen pro Seite:",
      skip_nav: "Zum Inhalt springen",
    },
    sort: {
      sort_by: "Sortieren nach %{field} %{order}",
      ASC: "aufsteigen",
      DESC: "absteigen",
    },
    auth: {
      auth_check_error: "Bitte einloggen um fortzufahren",
      user_menu: "Profil",
      username: "E-Mail",
      password: "Passwort",
      sign_in: "Anmelden",
      sign_in_error: "Fehler bei der Anmeldung",
      logout: "Abmelden",
    },
    notification: {
      updated:
        "Element wurde aktualisiert |||| %{smart_count} Elemente wurden aktualisiert",
      created: "Element wurde erstellt",
      deleted:
        "Element wurde gelöscht |||| %{smart_count} Elemente wurden gelöscht",
      bad_item: "Fehlerhaftes Elemente",
      item_doesnt_exist: "Das Element existiert nicht",
      http_error: "Fehler beim Kommunizieren mit dem Server",
      data_provider_error:
        "dataProvider Fehler. Prüfe die Konsole für Details.",
      i18n_error:
        "Die Übersetzungen für die angegebene Sprache können nicht geladen werden.",
      canceled: "Aktion abgebrochen",
      logged_out: "Ihr Session wurde beendet. Bitte erneut verbinden.",
      not_authorized: "Keine Berechtigung für Zugriff auf diese Ressource.",
      application_update_available: "Neue Version der Anwendung verfügbar",
    },
    validation: {
      required: "Benötigt",
      minLength: "Muss mindestens %{min} Zeichen lang sein",
      maxLength: "Darf maximal %{max} Zeichen lang sein",
      minValue: "Muss mindestens %{min} sein",
      maxValue: "Muss %{max} oder weniger sein",
      number: "Muss eine Nummer sein",
      email: "Muss eine gültige E-Mail sein",
      oneOf: "Es muss einer sein von: %{options}",
      regex: "Es muss folgendem regulären Ausdruck entsprechen: %{pattern}",
    },
    saved_queries: {
      label: "Gespeicherte Abfragen",
      query_name: "Name der Abfrage",
      new_label: "Aktuelle Abfrage speichern...",
      new_dialog_title: "Aktuelle Abfrage speichern als",
      remove_label: "Gespeicherte Abfrage entfernt",
      remove_label_with_name: 'Abfrage "%{name}" entfernen',
      remove_dialog_title: "Abfrage entfernen?",
      remove_message:
        "Sind Sie sicher, dass das Element von der Liste der gespeicherten Abfragen entfernt werden soll?",
      help: "Liste filtern und diese Abfrage für später speichern",
    },
    configurable: {
      customize: "Customize",
      configureMode: "Configure this page",
      inspector: {
        title: "Inspector",
        content: "Hover the application UI elements to configure them",
        reset: "Reset Settings",
        hideAll: "Hide All",
        showAll: "Show All",
      },
      Datagrid: {
        title: "Datagrid",
        unlabeled: "Unlabeled column #%{column}",
      },
      SimpleForm: {
        title: "Form",
        unlabeled: "Unlabeled input #%{input}",
      },
      SimpleList: {
        title: "List",
        primaryText: "Primary text",
        secondaryText: "Secondary text",
        tertiaryText: "Tertiary text",
      },
    },
  },
};
export default messages;
